/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type MergeTeamsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const mergeTeamsEntryPoint: EntryPoint<MergeTeamsEntryPointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForUserVisible<MergeTeamsEntryPointComponent>(
			/* webpackChunkName: "async-eoc-merge-teams" */ './ui/MergeTeams.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	},
);
